import { AppContextValue } from '@prisjakt/ui-app-context';

type Props = {
  status: number;
};

export default ({ status }: Props, { t }: AppContextValue) => ({
  title: `${t('errors', 'internal.unknown')} (${status})`,
});
